import { Form, ManualPaginator } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'

function OtherDonorsModal({
  active,
  donors,
  visibleDonors,
  draftExcludedDonorIds,
  draftSelectedCount,
  filteredDonorsCount,
  page,
  pages,
  setPage,
  search,
  setSearch,
  onClose,
  onSave,
  onCheckAll,
  onUncheckAll,
  onToggleDonor,
}) {
  return (
    <div className={`modal ${active ? 'active' : ''}`}>
      <a type="button" className="modal-overlay" aria-label="Fechar" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header">
          <a type="button" className="btn btn-clear float-right" onClick={onClose} />
          <div className="modal-title h5">Outros doadores</div>
          <div className="text-gray text-small">
            Escolha quais doadores devem entrar no relatório.
          </div>
        </div>
        <div className="modal-body">
          <Form.Group>
            <Form.Input
              className="input-sm"
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
                setPage(1)
              }}
              placeholder="Buscar doador pelo nome"
              autoComplete="off"
            />
          </Form.Group>

          <Form.Group>
            <button
              type="button"
              className="btn btn-link btn-sm p-0"
              onClick={draftSelectedCount === donors.length ? onUncheckAll : onCheckAll}
            >
              {draftSelectedCount === donors.length ? 'Desmarcar todos' : 'Selecionar todos'}
            </button>
          </Form.Group>

          {visibleDonors.map((donor) => {
            const checked = !draftExcludedDonorIds.includes(donor.id)

            return (
              <Form.Group key={donor.id}>
                <Form.Check>
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggleDonor(donor.id)}
                  />
                  <i className="form-icon" />
                  {donor.fullName}
                  {' '}
                  <span className="text-gray text-small">
                    ({donor.donationsCount || 0}
                    {' '}
                    {donor.donationsCount === 1 ? 'doação' : 'doações'})
                  </span>
                </Form.Check>
              </Form.Group>
            )
          })}

          {!filteredDonorsCount && (
            <div className="empty py-2">
              <p className="empty-title h6">Nenhum doador encontrado</p>
            </div>
          )}

          {filteredDonorsCount > 0 && (
            <div className="mt-2">
              <ManualPaginator
                paginatedList={{ count: filteredDonorsCount, page, pages }}
                setPage={setPage}
              />
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-sm mr-1" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="btn btn-primary btn-sm" onClick={onSave}>
            Concluir ({draftSelectedCount} selecionado{draftSelectedCount === 1 ? '' : 's'})
          </button>
        </div>
      </div>
    </div>
  )
}

OtherDonorsModal.propTypes = {
  active: PropTypes.bool.isRequired,
  donors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    donationsCount: PropTypes.number,
  })).isRequired,
  visibleDonors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    donationsCount: PropTypes.number,
  })).isRequired,
  draftExcludedDonorIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  draftSelectedCount: PropTypes.number.isRequired,
  filteredDonorsCount: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
  onUncheckAll: PropTypes.func.isRequired,
  onToggleDonor: PropTypes.func.isRequired,
}

export default OtherDonorsModal
